/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {ClrIconModule} from '../../icon/icon.module';
import {ClrConditionalModule} from '../../utils/conditional/conditional.module';
import {ClrCommonPopoverModule} from '../common/popover.module';

import {TOOLTIP_DIRECTIVES} from './index';
export class ClrTooltipModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, ClrCommonPopoverModule],
    declarations: [TOOLTIP_DIRECTIVES],
    exports: [TOOLTIP_DIRECTIVES, ClrConditionalModule, ClrIconModule]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ClrTooltipModule_tsickle_Closure_declarations() {
/** @type {?} */
ClrTooltipModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ClrTooltipModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
